import { useCountries } from 'api/requests/country';
import { WithdrawalAccountFormType } from 'modules/client/common/forms/withdrawalAccountForm';

export const useAddDialogWithdrawalAccount = () => {
  const { countries, loading: countriesLoading } = useCountries();

  const initialValues: WithdrawalAccountFormType = {
    bankCountry: null,
    swiftCode: '',
    bankAddress: '',
    bankName: '',
    checkingAccount: '',
    correspondentBankAccountNumber: '',
    correspondentBankSwiftCode: '',
    correspondentBankName: '',
    ownerConfirmationFiles: [],
    currency: null,
  };

  return {
    countries: countries ?? [],
    countriesLoading,
    initialValues,
  };
};
